import { useMemo } from "react";
import { atom, DefaultValue, selector, selectorFamily, useRecoilState, useResetRecoilState } from "recoil";
import { ServiceFilter } from "../filter/serviceFilter";
import { ServiceDescriptor } from "../models/ServiceDescriptor";
import apiService from "../services/api";

export const serviceRequestNumberState = atom({
    key: 'serviceRequestNumberState',
    default: 1
})

export const serviceEditMode = atom<'read' | 'edit'>({
    key: 'serviceEditMode',
    default: 'read'
})

export const serviceFilterAtom = atom<ServiceFilter>({
    key: 'serviceFilterAtom',
    default: {
        description: '',
        provincia: '',
        ambiente: ''
    }
})
export const serviceListAtom = atom<ServiceDescriptor[]>({
    key: 'serviceListAtom',
    default: [],
})

export const serviceAtom = atom<ServiceDescriptor>({
    key: 'serviceAtom',
    default: {
        id: 0,
        userCre: '',
        dateCre: null,
        userUpd: '',
        dateUpd: null,
        groupDescriptorId: 0,
        livello: 'Sixtema',
        sezione: 'Applicazioni',
        tipoAppl: '',
        tipologiaSito: '',
        ambiente: '',
        guid: '',
        info: '',
        note: '',
        sorter: 1,
        url: '',
        urlDescription: '',
        enabled: true,
        serviceImageUrl: '',
        escludiProvince: '',
        perProvince: '',
        area: '',
        fileEncoded: '',
        disabilitato: false,
    }

})

export const useService = () => {
    const [service, setService] = useRecoilState(serviceAtom)
    const resetService = useResetRecoilState(serviceAtom)
    const fetchService = useMemo(() => ((id: number) => apiService.getServiceDesciptor(id).then(n => {
        n && setService(n)
        return n
    })), [setService])
    return {
        service,
        setService,
        resetService,
        fetchService,
    }
} 

//Not used
export const serviceCurrentSelector = selectorFamily({
    key: 'sdCurrent',
    get: (id: number) => ({get}) => {
        const list = get(serviceListAtom)
        // console.log(`menuLivelliSelector: ${role} - ${base}`)
        const rv = list.find(x => x.id === id)
        return rv;
    }
})

//Used for update
export const updateServiceSelector = selector<ServiceDescriptor>({
    //export const serviceUpdateCurrent = selector({
    key: 'serviceUpdateCurrent',
    get: ({get}) => {
        //const myList = get(serviceListAtom).map(x => x)
        //let rv = myList.find(x => x.id === item.id)
        const rv = get(serviceAtom)
        return rv
    },
    set: ({get, set}, newValue) => {
        // const myList = get(serviceListAtom).map(x => x)
        // let itemFromState = myList.find(x => x.id === (newItem as ServiceDescriptor).id)
        // //va in errore sull'update dell'item e mi dice che non posso aggiornare
        // if (itemFromState) {
        //     //item.info = itemUpd.info
        //     itemFromState.note = (newItem as ServiceDescriptor).note
        // }
        // console.log('item updated', itemFromState)
        // set(serviceListAtom, myList)
        // return itemFromState
        if (!(newValue instanceof DefaultValue)) {
            if (newValue) {
                const newSd = newValue as ServiceDescriptor
                const lista = get(serviceListAtom)
                // if (newSd.id === 0) {
                //     const newId = get(serviceListAtom) + 1
                //     set(newIdState, newId)
                //     newSd.id = newId
                //     const newLista = [...lista, newSd]
                //     set(listState, newLista)
                // } else {
                const ele = lista.find(x => x.id === newSd.id)
                if (ele) {
                    //Sostituisco il ServiceDescriptor nell'indice
                    const idx = lista.findIndex(x => x.id === ele.id)
                    if (idx >= 0) {
                        const newLista = [...lista.slice(0, idx), newSd, ...lista.slice(idx + 1)]
                        set(serviceListAtom, newLista)
                    }
                }
            }
        }
    }
})

//For Add
export const addServiceSelector = selector<ServiceDescriptor>({
    key: 'addService',
    get: ({get}) => {
        //La get può ritornare qualunque cosa, purchè sia dello stesso tipo del selector
        return get(serviceAtom)
    },
    set: ({get, set}, itemAdd) => {
        set(serviceListAtom, [...get(serviceListAtom), itemAdd as ServiceDescriptor])
    },
})

//For Delete
export const deleteServiceSelector = selector<ServiceDescriptor>({
    key: 'deleteServiceSelector',
    get: ({get}) => {
        //La get può ritornare qualunque cosa, purchè sia dello stesso tipo del selector
        return get(serviceAtom)
    },
    set: ({get, set}, itemToRemove) => {
        let myNewList = get(serviceListAtom).filter(x => x.id !== (itemToRemove as ServiceDescriptor).id)
        set(serviceListAtom, myNewList)
    },
})


